import { render, staticRenderFns } from "./YesNoToggleButton.vue?vue&type=template&id=67f4e8ca&scoped=true&"
import script from "./YesNoToggleButton.vue?vue&type=script&lang=js&"
export * from "./YesNoToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./YesNoToggleButton.vue?vue&type=style&index=0&id=67f4e8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f4e8ca",
  null
  
)

export default component.exports